import { useChainId, useReadContract } from 'wagmi'
import { referralManagerAbi } from '@/abi/referralManagerAbi'
import { getContractAddress } from '@/config/contracts'

// Global referral-rate configuration: the operator-settable default share and the
// contract's hard cap (a constant, but read from chain so the UI can never drift).
export function useReferralConfig() {
    const chainId = useChainId()
    const manager = getContractAddress(chainId, 'referralManager')
    const enabled = Boolean(manager)

    const defaultShare = useReadContract({
        address: manager,
        abi: referralManagerAbi,
        functionName: 'defaultShareBps',
        chainId,
        query: { enabled },
    })
    const maxShare = useReadContract({
        address: manager,
        abi: referralManagerAbi,
        functionName: 'MAX_SHARE_BPS',
        chainId,
        query: { enabled },
    })

    return {
        defaultShareBps: defaultShare.data !== undefined ? Number(defaultShare.data) : undefined,
        maxShareBps: maxShare.data !== undefined ? Number(maxShare.data) : 5000,
        isLoading: defaultShare.isLoading || maxShare.isLoading,
    }
}
